import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * `<contextual-button-row>` — button-under-display contextual row.
 *
 * The defining primitive of OCP-400-style operator surfaces: a strip of
 * push-buttons sits immediately below a `<panel-display>`, and the button
 * captions are driven by what the display currently shows. Cross-reference
 * the display via slot composition; the row itself does not own the display.
 *
 * Slot contract:
 *   - default slot: a sequence of `<push-button>` children, one per column
 *
 * TODO(Phase 2): introduce a `legend` slot for the optional engraved strip
 * above the display once the layout primitive supports it; until then any
 * `slot="legend"` content silently falls through into the default slot.
 */
@customElement('contextual-button-row')
export class ContextualButtonRowElement extends LitElement {
  static override styles = [
    css`
      :host {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
        gap: var(--space-sm);
        inline-size: 100%;
      }
    `,
  ];

  override render() {
    // TODO(Phase 2): wire the row to its parent display via DOM querying
    // through the host's tree; relay display state changes into button
    // captions through a Lit Reactive Controller.
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'contextual-button-row': ContextualButtonRowElement;
  }
}
